import React from 'react'
import {BE_BASE_URL} from '@/App'
import {useEffect} from 'react'
import {getGuestTokenName, getUserTokenName} from '@/utils/tokenUtils'
import {useDispatch} from 'react-redux'
import {SET_USER_AUTH_ERROR, SET_USER_LOGGED} from '@/store/types'
import {useNavigate} from 'react-router-dom'
import {CircularProgress} from '@mui/material'
import Box from '@mui/material/Box'
import {ROUTES} from '@/utils/routes'

const AuthCallbackPage = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        fetch(BE_BASE_URL + '/auth/token', {
            credentials: 'include',
            mode: 'cors'
        })
            .then(res => {
                if (res.ok) {
                    return res.json()
                }
                return Promise.reject(res)
            })
            .then(res => {
                sessionStorage.setItem(getUserTokenName(), res.value)
                sessionStorage.removeItem(getGuestTokenName())
                return dispatch(SET_USER_LOGGED(true, 'user'))
            })
            .catch(() => {
                dispatch(SET_USER_AUTH_ERROR(true))
            })
            .finally( () => navigate(ROUTES.HOME))
    }, [])

    return (
        <Box
            bgcolor="#edf6f9"
            height="100vh"
            width="100vw"
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column">
            <CircularProgress size="5em"/>
            <h2>Logging in...</h2>
        </Box>
    )
}

export default AuthCallbackPage